/* eslint-disable import/order */
import { MenuIdPlans } from '@jira/navigation-apps__constants/src/MenuIdPlans.tsx';
import { SidebarIdPlanSettings } from '@jira/navigation-apps__constants/src/SidebarIdPlanSettings.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { planLayoutWithoutInvalidation } from '@jira/platform__layouts-jira-plan-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { softwarePlanSettingsAutoSchedulerRoute } from '@jira/router-routes__advanced-roadmaps-routes/src/softwarePlanSettingsAutoSchedulerRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import PlanSettingsAutoSchedulerPage, {
	LazyPlanSettingsAutoScheduler,
} from './ui/plan-settings-auto-scheduler/index.tsx';

export const softwarePlanSettingsAutoSchedulerRouteEntry: Route = createEntry(
	softwarePlanSettingsAutoSchedulerRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: PlanSettingsAutoSchedulerPage,
		layout: composeLayouts(globalLayout, planLayoutWithoutInvalidation),
		resources: [
			...getNavigationResources(),
			advancedRoadmapsPlanPageInitialChecksResource,
			...getPlansBacklogResource(),
			advancedRoadmapsReduxStoreStateResource,
		],
		preloadOptions: {
			earlyChunks: ['advanced-roadmaps-early-entry'],
		},
		navigation: {
			sidebarId: SidebarIdPlanSettings,
			menuId: MenuIdPlans,
		},
		forPaint: [LazyAtlassianNavigation, LazyPlanSettingsAutoScheduler],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
